// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"edit"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M14.1048 6.00427L4.78744 15.3216L3.99805 20.0001L8.67652 19.2107L17.9939 9.89336L14.1048 6.00427Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M17.9936 9.89339L21.0506 6.83635L17.1615 2.94727L14.1045 6.0043L17.9936 9.89339Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14.1048 6.00427L4.78744 15.3216L3.99805 20.0001L8.67652 19.2107L17.9939 9.89336M14.1048 6.00427L17.9939 9.89336M14.1048 6.00427L17.1615 2.94727L21.0506 6.83635L17.9939 9.89336","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const EditIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'edit',
    ref,
    icon: element,
  },
));

EditIcon.displayName = 'EditIcon';

export default EditIcon;
